<template>
	<modal v-show="opened" @close="close">
		<template v-slot:header>
			<div class="modal_header">{{ titleModal }}</div>
		</template>
		<slot></slot>
		<template v-slot:footer>
			<div class="modal_footer">
				<md-button class="md-primary md-button-large" aria-label="close" @click="close">Cancel</md-button>
				<md-button
					class="md-primary md-raised md-button-large"
					aria-label="apply"
					:disabled="applyBtn.disabled"
					@click="applyBtn.func"
				>
					<base-icon
						v-if="applyBtn.icon"
						:icon-name="applyBtn.icon"
						:icon-color="applyBtn.color"
					/>
					{{ applyBtn.name }}
				</md-button>
			</div>
		</template>
	</modal>
</template>

<script>
import Modal from '@/shared/Modal.vue';

export default {
	name: 'OptionModal',
	components: {Modal},
	props: {
		titleModal: {type: String, default: ''},
		applyBtn: {
			type: Object,
			default: () => ({
				name: '',
				disabled: false,
				color: '#ffffff',
				func: () => {},
			}),
		},
	},
	data() {
		return {
			opened: false,
		};
	},
	mounted() {
		this.$nextTick(() => {
			this.opened = true;
		});
	},
	methods: {
		close() {
			this.$emit('on-close');
		},
	},
};
</script>

<style lang="scss" scoped>
.modal-mask {
  padding: 16px;
	::v-deep {
    .modal-container {
			min-height: 242px;
      width: 100%;
      min-width: auto;
			max-width: 600px;
			padding: 24px;
			.header {
				padding-bottom: 8px;
				&.display-2 {
					@include font-styles('Futura W01 Medium', 500);
					@include textStyles(34, 48, 0.25);
				}
			}
			.content {
				.body-1 {
					overflow-wrap: break-word;
					word-wrap: break-word;
					word-break: break-word;
				}
			}
		}
		.modal_footer {
			width: 100%;
			display: flex;
			justify-content: flex-end;
			padding-top: 8px;
			.md-button:last-of-type {
				margin-left: 1rem;
				.md-button-content .icon {
					margin-right: 0 !important;
				}
			}
		}
	}
}
</style>
